module.exports = __webpack_public_path__ + "static/media/axure.f7284609.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/axure.png
// module id = 70
// module chunks = 0